import { request } from "../helper/axios_helper";

const BASE = "/api/auth/dashboard";

export const getDashboardSummary = (userEmail) =>
  request("GET", `${BASE}/summary?userEmail=${encodeURIComponent(userEmail)}`);

export const getDashboardTrend = (days = 30) =>
  request("GET", `${BASE}/trend?days=${days}`);

export const getDashboardLibrary = () =>
  request("GET", `${BASE}/library`);

export const getDashboardRecentRuns = (userEmail, limit = 8) =>
  request("GET", `${BASE}/runs/recent?userEmail=${encodeURIComponent(userEmail)}&limit=${limit}`);

export const getDashboardMasterSuiteHealth = (userEmail) =>
  request("GET", `${BASE}/mastersuite/health?userEmail=${encodeURIComponent(userEmail)}`);

export const getDashboardJobBreakdown = (userEmail, days = 7) =>
  request("GET", `${BASE}/jobs/breakdown?userEmail=${encodeURIComponent(userEmail)}&days=${days}`);

export const getDashboardFailureHeatmap = (userEmail, days = 28) =>
  request("GET", `${BASE}/heatmap?userEmail=${encodeURIComponent(userEmail)}&days=${days}`);

export const getDashboardWidgetConfig = (userEmail) =>
  request("GET", `${BASE}/config?userEmail=${encodeURIComponent(userEmail)}`);

export const saveDashboardWidgetConfig = (userEmail, widgetConfig) =>
  request("PUT", `${BASE}/config`, {
    userEmail,
    widgetConfig: JSON.stringify(widgetConfig),
  });
